export enum ProcessTrackingMeasurementTypeEnum {
  General  = "General",
  Route = "Route",
  Service = "Service",
  Relation = "Relation",
  Job = "Job",
  Account = "Account",
  Agent = "Agent",
  CallTemplates = "CallTemplates",
  Percentage = "Percentage"
}

